import React from 'react';
import '../../node_modules/grommet-css'
import { withRouter } from 'react-router-dom'

class FooterItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            hover: false
        };

        this.toggleHover.bind(this);
        this.gotoLink = this.gotoLink.bind(this);
    }

    toggleHover(e) {
        if (this) {
            this.setState(
                {
                    hover: !this.state.hover
                }
            );
            console.log("toggleHover()");
        }
        e.stopPropagation();
    }

    gotoLink() {
        if("pushTo" in this.props) { this.props.history.push(this.props.pushTo); }
        if("openNew" in this.props) { window.open(this.props.openNew, "_blank"); }
        if("emailTo" in this.props) { window.location.href = `mailto:${this.props.emailTo}`; }
    }

    render() {

        var currStyle = this.props.normstyle;
        if (this.state.hover) currStyle = this.props.hoverstyle;
        if(this.props.text === "") {
            return (<br/>)
        } else {
            return (
                <span
                    style={currStyle}
                    onClick={this.gotoLink}
                    onMouseOver={(e) => this.toggleHover(e)}
                    onMouseOut={(e) => this.toggleHover(e)}
                >
                    {this.props.text}
            </span>
            );
        }
    }
}

export default withRouter(FooterItem)



// WEBPACK FOOTER //
// src/static/FooterItem.js